require('intersection-observer');

import { fetchText } from '../fetch-helper/fetch-helper';
import {
    checkForModuleToLoad,
    getModuleToLoad,
    bindModuleToLoad,
    appendScript,
    getSrcToLoad
} from '../utility-functions/utility-functions';

const LAZY_SELECTOR: string = '.js-lazy-html';
const LAZY_OPTIONS: IntersectionObserverInit = {
    rootMargin: '60%',
    threshold: 0
};

const observerCallback: IntersectionObserverCallback = (entries, observer) => {
    entries.forEach(async (entry) => {
        const URL = (entry.target as HTMLDivElement).dataset.url;

        if (entry.isIntersecting && !entry.target.innerHTML.length) {
            const html = await fetchText(URL,null);
            entry.target.innerHTML = html;

            // same check as off canvas panel, invokes script page within partial.
            if (checkForModuleToLoad(entry.target)) {
                const module = getModuleToLoad(entry.target);
                const moduleSrc = getSrcToLoad(
                    checkForModuleToLoad(entry.target)
                );

                appendScript(moduleSrc).then(() => {
                    bindModuleToLoad(module);
                });

                return;
            }
        }
    });
};

export default () => {
    const observerItems: NodeListOf<HTMLElement> =
        document.querySelectorAll(LAZY_SELECTOR);
    if (!observerItems.length) return;
    const observer = new IntersectionObserver(observerCallback, LAZY_OPTIONS);
    observerItems.forEach((img) => observer.observe(img));
};
